module.exports = "<p>\n  deputation-authorization-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/deputaion/deputation-authorization/deputation-authorization-form/deputation-authorization-form.component.html
// module id = ./src/app/hrms/deputaion/deputation-authorization/deputation-authorization-form/deputation-authorization-form.component.html
// module chunks = main